import { mapState } from "vuex";

export default {
  methods: {
    isRecognitionsEnabled(clientId = undefined) {
      if (clientId) {
        const client = (this.clients || []).find((c) => c.clientId === clientId);
        if (client) return client.recognitionsEnabled;
      }
      return this.userProfile.Client.recognitionsEnabled;
    },
  },
  computed: {
    ...mapState(["userProfile", "clients"]),
  },
};
